import { connect } from 'react-redux'

import FooterLinks from '../../components/FooterLinks/FooterLinks'
import { openCookieSettings } from '../../actions/CookieSettings'

const mapStateToProps = (state) => ({
    links: state.footerLinks,
})

const mapDispatchToProps = (dispacth) => ({
    onOpenCookieSettings: () => {
        dispacth(openCookieSettings())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(FooterLinks)
